import React from "react";
import HelpMessageItemAddition from "./HelpMessageItemAddition";

const HelpMessageItems = (props) => {
    return (
        <>
            {props.panel && <>
                <div id={"help-message-items-panel-" + props.helpMessage.id}
                     className="inb-c-item-details inb-c-order-reservations row">
                    <HelpMessageItemAddition
                        helpMessageItems={props.helpMessage?.help_message_items}
                        id={props.helpMessage.id}
                        helpMessage={props.helpMessage}
                        dispatch={props.data.dispatch}
                    />
                </div>
            </>
            }
            {!props.panel &&
                <HelpMessageItemAddition
                    helpMessageItems={props.helpMessage?.help_message_items}
                    id={props.helpMessage.id}
                    helpMessage={props.helpMessage}
                    dispatch={props.data.dispatch}
                />
            }
        </>
    );
}

export default HelpMessageItems;